import { map } from 'rxjs/operators';
import { UIDispatchers } from 'src/app/store/ui/ui.dispatchers';
import { ChatDispatchers } from 'src/app/store/chats/chat.dispatchers';
import { AuthDispatchers } from 'src/app/store/auth/auth.dispatchers';
import { MessageDispatchers } from 'src/app/store/messages/message.dispatchers';
import { RootStoreSelectors } from 'src/app/store/root-store.selectors';
import { Router } from '@angular/router';
import * as i0 from "@angular/core";
import * as i1 from "../../store/root-store.selectors";
import * as i2 from "../../store/ui/ui.dispatchers";
import * as i3 from "../../store/auth/auth.dispatchers";
import * as i4 from "../../store/messages/message.dispatchers";
import * as i5 from "../../store/chats/chat.dispatchers";
import * as i6 from "@angular/router";
export class DashboardService {
    constructor(_selectors, _uiDispatchers, _authDispatchers, _messageDispatchers, _chatDispatchers, _route) {
        this._selectors = _selectors;
        this._uiDispatchers = _uiDispatchers;
        this._authDispatchers = _authDispatchers;
        this._messageDispatchers = _messageDispatchers;
        this._chatDispatchers = _chatDispatchers;
        this._route = _route;
        this.notifyCount = 0;
        this.profileSubsc = null;
    }
    logout() {
        this._authDispatchers.resetStore();
        this._authDispatchers.logOut();
        this._route.navigate(['/login']);
    }
    setChannelInfo(chatID, updatedChatProps, reference) {
        updatedChatProps.id = chatID;
        this._chatDispatchers.updateChat(updatedChatProps, reference);
    }
    uploadChatImage(chatID, selectedFile) {
        this._chatDispatchers.uploadChatPhoto(chatID, selectedFile);
    }
    setPageNumber(action) {
        this._uiDispatchers.setPageNumber(action);
    }
    setSearchKeyword(searchString) {
        this._uiDispatchers.setSearchKeyWord(searchString);
    }
    setSection(direction, subSection) {
        this._uiDispatchers.setSection(direction, subSection);
    }
    setScheduleDate(scheduleDate) {
        this._uiDispatchers.dateSelected(scheduleDate);
    }
    deselectChannel() {
        this._messageDispatchers.deselectChannel();
    }
    setSelect(type) {
        // this._messageDispatchers.setSelect(type);
    }
    listScheduleMessages() {
        this._messageDispatchers.listScheduleMessages();
    }
    /*********************** Store Selectors *********************************************/
    // TODO: Move this selectors fro auth dispatchers
    get chatAdminName() {
        return this._authDispatchers.getLoginName();
    }
    get selectedChatName$() {
        return this._selectors.selectedChatName$;
    }
    get authCollection$() {
        return this._selectors.authCollection$;
    }
    get allChannels$() {
        return this._selectors.channels$.pipe(map(channels => channels.filter(channel => channel.detailsReceived)));
    }
    get messagesCollection$() {
        return this._selectors.messagesCollection$;
    }
    get awardMessages$() {
        return this._selectors.awardMessages$;
    }
    get scheduleMessages$() {
        return this._selectors.scheduleMessages$;
    }
    get selectedChat$() {
        return this._selectors.getSelectedChat$();
    }
    get effectiveParentMessage$() {
        return this._selectors.getEffectiveChannelPost$();
    }
    get effectiveSelectedChat$() {
        return this._selectors.getEffectiveSelectedChat$();
    }
    get uiCollection$() {
        return this._selectors.uiCollection$;
    }
    get privileges$() {
        return this._selectors.privileges$;
    }
    getUserByID$(senderID) {
        return this._selectors.getProfileByID$(senderID);
    }
    get getChannelsAndGroupList$() {
        return this._selectors.getChannelsAndGroupList$();
    }
}
DashboardService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DashboardService_Factory() { return new DashboardService(i0.ɵɵinject(i1.RootStoreSelectors), i0.ɵɵinject(i2.UIDispatchers), i0.ɵɵinject(i3.AuthDispatchers), i0.ɵɵinject(i4.MessageDispatchers), i0.ɵɵinject(i5.ChatDispatchers), i0.ɵɵinject(i6.Router)); }, token: DashboardService, providedIn: "root" });
